import { useState, useEffect } from 'react';
import { useEventEmitter } from 'hooks';

export const useInputNumberGroup = ({options: values, onChange: setOptionsChecked}) => {
  const events = useEventEmitter();
  const [ options, setOptions ] = useState(values);
  const [ optionsTotalQuantity, setOptionsTotalQuantity ] = useState(0);

  const makeCalculation = ({priceValue, priceValueStart, quantityValue}) => {
    return priceValueStart ? {
      totalQuantity: quantityValue - 1,
      total: (quantityValue - 1) * priceValue
    } : {
      totalQuantity: quantityValue,
      total: quantityValue * priceValue
    }
  };

  const makeToChecked = (options, optionIndex, optionQuantityValue) => {
    return options.map((option, index) => {
      const { priceValue, priceValueStart = null } = option;
      const quantityValue = optionIndex === index ? optionQuantityValue : option.quantityValue;
      const quantityTotals = makeCalculation({
        priceValue,
        priceValueStart,
        quantityValue
      });

      return {
        ...option,
        ...quantityTotals,
        quantityValue,
        isChecked: !!quantityValue
      }
    });
  };

  const makeTotalQuantity = (options) => {
    return options.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.quantityValue;
    }, 0);
  };

  const makeQuantityValue = (optionQuantityValue, optionIndex) => {
    let quantityValueMin = options[optionIndex].quantityValueMin;
    let quantityValueMax = options[optionIndex].quantityValueMax;
    let quantityValue;

    quantityValue = optionQuantityValue;
    quantityValue = quantityValue > quantityValueMax ? quantityValueMax : quantityValue;
    quantityValue = quantityValue < quantityValueMin ? quantityValueMin : quantityValue;

    return quantityValue;
  };

  const onChangeOptions = (value, event, optionIndex) => {
    const quantity = +(event.target.value || value);
    const optionQuantity = makeQuantityValue(quantity, optionIndex);
    const optionsChecked = makeToChecked(options, optionIndex, optionQuantity);
    const optionsTotalQuantity = makeTotalQuantity(options);

    setOptions(optionsChecked);
    setOptionsChecked(optionsChecked);
    setOptionsTotalQuantity(optionsTotalQuantity);
  };

  events.on('Increase', (optionId) => {
    const optionIndex = options.findIndex(option => option.id === optionId);

    if (optionIndex > -1) {
      onChangeOptions(
        null,
        {target: { value: options[optionIndex].quantityValue + 1 }},
        optionIndex
      );
    }
  });

  events.on('Decrease', (optionId) => {
    const optionIndex = options.findIndex(option => option.id === optionId);

    if (optionIndex > -1) {
      onChangeOptions(
        null,
        {target: { value: options[optionIndex].quantityValue - 1 }},
        optionIndex
      );
    }
  });

  useEffect(() => {
    const optionsChecked = makeToChecked(options);
    const optionsTotalQuantity = makeTotalQuantity(options);

    setOptionsChecked(optionsChecked);
    setOptionsTotalQuantity(optionsTotalQuantity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return [
    optionsTotalQuantity,
    onChangeOptions
  ];
};
